'use client';

import { ChangeEvent } from 'react';

import { useTranslations } from '@/components/language-provider';
import { Locale } from '@/i18n/messages';

function GlobeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" {...props}>
      <path d="M12 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10Z" />
      <path d="M2 12h20" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10Z" />
    </svg>
  );
}

export function LanguageSwitcher() {
  const { locale, setLocale, messages, locales } = useTranslations();

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const next = event.target.value as Locale;
    setLocale(next);
  };

  return (
    <label className="flex items-center gap-2 rounded-full border border-border bg-surface px-3 py-1.5 text-sm font-medium text-foreground shadow-sm focus-within:outline focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-ring">
      <GlobeIcon className="size-4 text-muted-foreground" />
      <span className="sr-only">{messages.toggles.language}</span>
      <select
        className="bg-transparent text-sm font-medium outline-none"
        value={locale}
        aria-label={messages.toggles.language}
        onChange={handleChange}
      >
        {locales.map((option) => (
          <option key={option.value} value={option.value} className="bg-surface text-foreground">
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
